import { haveFilterQuery, paginator, haveSort } from '../common/auxFun'

export const endpointsSpainFuelStations = {
  LOAD: (filter, sort, limit, skip) =>
    `/v1/fuelStations${haveFilterQuery(filter)}${paginator(limit, skip)}${haveSort(sort)}`,
  FUEL_STATIONS: '/v1/fuelStations/',
  PRICE_MINETUR: (id) => `/v1/fuelStations/priceMinetur/${id}`,
}
